import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, UpdateInvoiceDeadlinePayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'UPDATE_INVOICE_DEADLINE_',
  }
);

export interface UpdateInvoiceDeadlineState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface UpdateInvoiceDeadlineRequestAction {
  payload: UpdateInvoiceDeadlinePayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: UpdateInvoiceDeadlineState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: UpdateInvoiceDeadlineState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: UpdateInvoiceDeadlineState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: UpdateInvoiceDeadlineState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: UpdateInvoiceDeadlineState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const updateInvoiceDeadline = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const UpdateInvoiceDeadlineTypes = Types;
export const UpdateInvoiceDeadlineActions = Creators;
